import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import GlobalSearchState from 'flarum/forum/states/GlobalSearchState';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import Button from 'flarum/common/components/Button';
import LinkButton from 'flarum/common/components/LinkButton';
import Component from 'flarum/common/Component';
import type Mithril from 'mithril';

// // 自定义 SVG 图标组件
// const CustomIcon = ({ type }: { type: 'sun' | 'moon' | 'auto' }) => {
//   if (type === 'sun') {
//     return (
//       <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
//         <g clip-path="url(#clip0_517_31920)">
//           <path
//             d="M10.833 20H9.16699V16.667H10.833V20ZM3.33301 18.333H1.66699V16.667H3.33301V18.333ZM18.333 18.333H16.667V16.667H18.333V18.333ZM5 16.667H3.33301V15H5V16.667ZM16.667 16.667H15V15H16.667V16.667ZM13.333 15H6.66699V13.333H13.333V15ZM6.66699 13.333H5V6.66699H6.66699V13.333ZM15 13.333H13.333V6.66699H15V13.333ZM3.33301 10.833H0V9.16699H3.33301V10.833ZM20 10.833H16.667V9.16699H20V10.833ZM13.333 6.66699H6.66699V5H13.333V6.66699ZM5 5H3.33301V3.33301H5V5ZM16.667 5H15V3.33301H16.667V5ZM3.33301 3.33301H1.66699V1.66699H3.33301V3.33301ZM10.833 3.33301H9.16699V0H10.833V3.33301ZM18.333 3.33301H16.667V1.66699H18.333V3.33301Z"
//             fill="#FFFAEA"
//           />
//         </g>
//         <defs>
//           <clipPath id="clip0_517_31920">
//             <rect width="20" height="20" fill="white" />
//           </clipPath>
//         </defs>
//       </svg>
//     );
//   }
//   if (type === 'moon') {
//     return (
//       <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
//         <path
//           d="M15 18.333H6.66699V16.667H15V18.333ZM6.66699 16.667H5V15H6.66699V16.667ZM16.667 16.667H15V15H16.667V16.667ZM5 15H3.33301V13.333H5V15ZM18.333 15H16.667V11.667H15V10H16.667V8.33301H18.333V15ZM3.33301 13.333H1.66699V5H3.33301V13.333ZM15 13.333H10V11.667H15V13.333ZM10 11.667H8.33301V10H10V11.667ZM8.33301 10H6.66699V5H8.33301V10ZM5 5H3.33301V3.33301H5V5ZM11.667 3.33301H10V5H8.33301V3.33301H5V1.66699H11.667V3.33301Z"
//           fill="black"
//         />
//       </svg>
//     );
//   }
//   // auto mode
//   return (
//     <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className="icon">
//       <path
//         d="M15 18.333H6.66699V16.667H15V18.333ZM6.66699 16.667H5V15H6.66699V16.667ZM16.667 16.667H15V15H16.667V16.667ZM5 15H3.33301V13.333H5V15ZM18.333 15H16.667V11.667H15V10H16.667V8.33301H18.333V15ZM3.33301 13.333H1.66699V5H3.33301V13.333ZM15 13.333H10V11.667H15V13.333ZM10 11.667H8.33301V10H10V11.667ZM8.33301 10H6.66699V5H8.33301V10ZM5 5H3.33301V3.33301H5V5ZM11.667 3.33301H10V5H8.33301V3.33301H5V1.66699H11.667V3.33301Z"
//         fill="currentColor"
//       />
//     </svg>
//   );
// };

interface Slide {
  id: string;
  attributes: {
    imageUrl: string;
    link?: string;
    title?: string;
    text?: string;
    isEnabled: boolean;
  };
}

interface CarouselConfig {
  interval: number;
  width: string;
  height: string;
  autoplay: boolean;
  showNavigation: boolean;
}

interface ApiResponse {
  data?: Slide[];
}

class HeroCarouselView extends Component<{}> {
  slides: Slide[] = [];
  currentIndex: number = 0;
  interval: number | null = null;
  loading: boolean = true;
  config!: CarouselConfig;
  isInitialized: boolean = false;

  oninit(vnode: Mithril.Vnode<{}, this>) {
    super.oninit(vnode);
    this.isInitialized = true;

    // 获取配置
    this.config = {
      interval: app.forum.attribute('agilexHeroCarouselInterval') || 5000,
      width: app.forum.attribute('agilexHeroCarouselWidth') || '100%',
      height: app.forum.attribute('agilexHeroCarouselHeight') || '400px',
      autoplay: app.forum.attribute('agilexHeroCarouselAutoplay') !== false,
      showNavigation: app.forum.attribute('agilexHeroCarouselShowNavigation') !== false,
    };

    // 加载轮播图数据
    this.loadSlides();
  }

  loadSlides() {
    if (!app || !app.forum) return;

    const apiUrl = app.forum.attribute('apiUrl');
    if (!apiUrl) {
      console.error('API URL not found');
      return;
    }

    app
      .request<ApiResponse>({
        method: 'GET',
        url: apiUrl + '/hero-carousel-slides',
      })
      .then((response: ApiResponse) => {
        if (!this.isInitialized) return;

        this.slides = response.data?.filter((slide: Slide) => slide.attributes.isEnabled) || [];
        this.loading = false;

        // 重置当前索引
        if (this.currentIndex >= this.slides.length) {
          this.currentIndex = 0;
        }

        // 开始自动播放
        if (this.config?.autoplay && this.slides.length > 1) {
          this.startAutoplay();
        }

        m.redraw();
      })
      .catch((error: any) => {
        if (!this.isInitialized) return;

        console.error('Failed to load slides:', error);
        this.loading = false;
        this.slides = [];
        m.redraw();
      });
  }

  startAutoplay() {
    this.interval = setInterval(() => {
      this.next();
    }, this.config.interval);
  }

  stopAutoplay() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    m.redraw();
  }

  prev() {
    this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    m.redraw();
  }

  goToSlide(index: number) {
    this.currentIndex = index;
    m.redraw();

    // 重置自动播放
    if (this.config.autoplay) {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  onremove(vnode: Mithril.VnodeDOM<{}, this>) {
    this.isInitialized = false;
    this.stopAutoplay();
    super.onremove(vnode);
  }

  view(vnode: Mithril.Vnode<{}, this>) {
    if (this.loading) {
      return (
        <div className="AgilexHeroCarousel" style={{ height: this.config.height }}>
          <div className="AgilexHeroCarousel-loading">Loading...</div>
        </div>
      );
    }

    // 如果没有启用的轮播图，不显示轮播组件
    if (!this.slides || this.slides.length === 0) {
      console.log('No slides to display');
      return null;
    }

    return (
      <div
        className="AgilexHeroCarousel"
        style={{
          width: this.config.width,
          height: this.config.height,
          margin: 'auto',
        }}
        onmouseenter={() => this.stopAutoplay()}
        onmouseleave={() => this.config.autoplay && this.startAutoplay()}
      >
        {/* 轮播图片 */}
        <div
          className="AgilexHeroCarousel-track"
          style={{
            transform: `translateX(-${this.currentIndex * 100}%)`,
          }}
        >
          {this.slides.map((slide: Slide) => (
            <div
              key={slide.id}
              className="AgilexHeroCarousel-slide"
              style={{
                backgroundImage: `url(${slide.attributes.imageUrl})`,
              }}
            >
              {slide.attributes.link && <a className="AgilexHeroCarousel-link" href={slide.attributes.link} />}
              <div className="AgilexHeroCarousel-content">
                {slide.attributes.title && <h2 className="AgilexHeroCarousel-title">{slide.attributes.title}</h2>}
                {slide.attributes.text && <p className="AgilexHeroCarousel-text">{slide.attributes.text}</p>}
              </div>
            </div>
          ))}
        </div>

        {/* 导航按钮 */}
        {this.config.showNavigation && this.slides.length > 1 && (
          <>
            <button className="AgilexHeroCarousel-prev" onclick={() => this.prev()}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M6.66699 10.833L6.66699 9.16699L8.33301 9.16699L8.33301 10.833L6.66699 10.833ZM8.33301 9.16699L8.33301 7.5L10 7.5L10 9.16699L8.33301 9.16699ZM8.33301 12.5L8.33301 10.833L10 10.833L10 12.5L8.33301 12.5ZM10 7.5L10 5.83301L11.667 5.83301L11.667 7.5L10 7.5ZM10 14.167L10 12.5L11.667 12.5L11.667 14.167L10 14.167ZM11.667 5.83301L11.667 4.16699L13.333 4.16699L13.333 5.83301L11.667 5.83301ZM11.667 15.833L11.667 14.167L13.333 14.167L13.333 15.833L11.667 15.833Z"
                  fill="white"
                />
              </svg>
            </button>
            <button className="AgilexHeroCarousel-next" onclick={() => this.next()}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M13.333 10.833L13.333 9.16699L11.667 9.16699L11.667 10.833L13.333 10.833ZM11.667 9.16699L11.667 7.5L10 7.5L10 9.16699L11.667 9.16699ZM11.667 12.5L11.667 10.833L10 10.833L10 12.5L11.667 12.5ZM10 7.5L10 5.83301L8.33301 5.83301L8.33301 7.5L10 7.5ZM10 14.167L10 12.5L8.33301 12.5L8.33301 14.167L10 14.167ZM8.33301 5.83301L8.33301 4.16699L6.66699 4.16699L6.66699 5.83301L8.33301 5.83301ZM8.33301 15.833L8.33301 14.167L6.66699 14.167L6.66699 15.833L8.33301 15.833Z"
                  fill="white"
                />
              </svg>
            </button>

            {/* 指示器 */}
            <div className="AgilexHeroCarousel-indicators">
              {this.slides.map((_, index) => (
                <button
                  key={index}
                  className={`AgilexHeroCarousel-indicator ${index === this.currentIndex ? 'active' : ''}`}
                  onclick={() => this.goToSlide(index)}
                />
              ))}
            </div>
          </>
        )}
      </div>
    );
  }
}

// Hero Carousel 初始化器
app.initializers.add('agilex-hero-carousel-forum', () => {
  override(IndexPage.prototype, 'hero', function () {
    return <HeroCarouselView />;
  });
});

// // 精华帖导航按钮初始化器
// app.initializers.add('agilex-frontpage-nav', () => {
//   // 扩展 GlobalSearchState，修改其 stickyParams 方法
//   extend(GlobalSearchState.prototype, 'stickyParams', function (params) {
//     // 如果正在切换路由（不是在同一页面内筛选），则清除 q 参数
//     if (app.current.get('routeName') !== m.route.get().split('?')[0]) {
//       delete params.q;
//     }
//     return params;
//   });

//   extend(IndexPage.prototype, 'navItems', function (items) {
//     const isFrontpage = window.location.search === '?q=is:frontpage';
//     // 添加精华帖按钮
//     items.add(
//       'frontpage',
//       <LinkButton
//         href="/?q=is:frontpage"
//         icon="fas fa-star"
//         active={isFrontpage} // 明确设置激活状态
//       >
//         {app.translator.trans('core.forum.index_sort.front_button')}
//       </LinkButton>,
//       60
//     );

//     // 修改"全部主题"按钮的激活状态
//     const allDiscussions = items.get('allDiscussions');
//     if (allDiscussions) {
//       items.replace(
//         'allDiscussions',
//         <LinkButton
//           href={app.route('index')}
//           icon="far fa-comments"
//           active={!isFrontpage && app.current.get('routeName') === 'index'} // 只在非精华帖页面且是首页时激活
//         >
//           {app.translator.trans('core.forum.index.all_discussions_link')}
//         </LinkButton>
//       );
//     }
//   });
// });

// 自定义 Night Mode 图标初始化器
// app.initializers.add('agilex-customize-nightmode-icons', () => {
//   // 检查是否安装了 FoF Night Mode 扩展
//   if (!flarum.extensions['fof-nightmode']) {
//     console.log('FoF Night Mode extension not found, skipping icon customization');
//     return;
//   }

//   // 获取主题辅助函数
//   const getTheme = () => {
//     const user = app.session.user;
//     if (!user) {
//       return app.forum.attribute('fof-nightmode.default_theme') || 0;
//     }

//     const prefs = user.preferences();
//     if (prefs && prefs.fofNightMode_perDevice) {
//       const cookie = document.cookie.split('; ').find(row => row.startsWith('flarum_nightmode='));
//       if (cookie) {
//         return parseInt(cookie.split('=')[1]) || 0;
//       }
//     }

//     return (prefs && prefs.fofNightMode) || 0;
//   };

//   const getIsLight = (theme: number) => {
//     if (theme === 0) {
//       // Auto
//       return !window.matchMedia('(prefers-color-scheme: dark)').matches;
//     }
//     return theme === 1; // Light = 1, Dark = 2
//   };
//   // 修改头部的 Night Mode 按钮图标
//   extend(HeaderSecondary.prototype, 'items', function (items) {
//     // 如果用户已登录且没有开启"始终显示"选项，则不显示头部按钮
//     if (app.session.user && !app.forum.attribute('fofNightMode.showThemeToggleOnHeaderAlways')) {
//       return;
//     }

//     const theme = getTheme();
//     const isLight = getIsLight(theme);
//     const iconType = theme === 0 ? 'auto' : isLight ? 'sun' : 'moon';
//     items.add(
//       'nightmode',
//       <button
//         className="Button Button--link"
//         onclick={() => {
//           if (app.session.user) {
//             app.session.user
//               .savePreferences({
//                 fofNightMode: isLight ? 2 : 1,
//               })
//               .then(() => window.location.reload());
//           } else {
//             document.cookie = `flarum_nightmode=${isLight ? 2 : 1}; path=/; expires=Tue, 19 Jan 2038 03:14:07 GMT`;
//             window.location.reload();
//           }
//         }}
//       >
//         {CustomIcon({ type: iconType })}
//         {/* <CustomIcon type={iconType} /> */}
//         {/* {app.translator.trans('fof-nightmode.forum.header.nightmode_button')} */}
//       </button>,
//       15
//     );
//   });

//   // // 修改下拉菜单中的 Night Mode 图标
//   // extend(SessionDropdown.prototype, 'items', function (items) {
//   //   const isLight = getIsLight(getTheme());
//   //   const itemKey = isLight ? 'nightmode' : 'daymode';

//   //   items.remove(itemKey);
//   //   items.add(
//   //     itemKey,
//   //     <Button
//   //       className="Button Button--link"
//   //       onclick={() => {
//   //         if (app.session.user) {
//   //           app.session.user
//   //             .savePreferences({
//   //               fofNightMode: isLight ? 2 : 1,
//   //             })
//   //             .then(() => window.location.reload());
//   //         }
//   //       }}
//   //     >
//   //       <CustomIcon type={isLight ? 'moon' : 'sun'} />
//   //       {app.translator.trans(`fof-nightmode.forum.${isLight ? 'night' : 'day'}`)}
//   //     </Button>,
//   //     -1
//   //   );
//   // });

//   console.log('Night Mode icons customized successfully');
// });
